import Swiper from 'swiper/dist/js/swiper.min';
import imagesLoaded from 'imagesloaded';

/**
 * Expose the swiper instances
 * @type {{swipers: Array, push: swipers.push, update: swipers.update}}
 */
export const swipers = {
  swipers: [],

  push: function (swiper) {
    this.swipers.push(swiper);
  },

  update: function (show) {
    if (this.swipers.length) {
      this.swipers.forEach(function(swiper, index) {
        swiper.update();
        swiper.lazy.load();
        if (show) {
          setTimeout(() => {
            $(swiper.el).addClass('full-page-nav__swiper--visible');
          }, index * 150);
        }
      });
    }
  }
};

const initFullPageNav = function() {
  let el = $('.full-page-nav__swiper');
  if (el.length) {
    let swiper = new Swiper('.full-page-nav__swiper', {
      slidesPerView: 4,
      spaceBetween: 40,
      autoHeight: true,
      preloadImages: false,
      lazy: {
        elementClass: 'project-nav-list__image',
        loadingClass: 'project-nav-list__image--loading',
        loadedClass: 'project-nav-list__image--loaded',
        preloaderClass: 'project-nav-list__preloader',
        loadPrevNext: true,
        loadPrevNextAmount: 2
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          freeMode: true,
          slidesPerView: 1.2
        },
        1024: {
          freeMode: false,
          slidesPerView: 3
        }
      }
    });

    if (swiper.length !== undefined) {
      swiper.forEach((swiper) => {
        swipers.push(swiper);
      });
    } else {
      swipers.push(swiper);
    }

    // Reformat the slider when images are loaded
    imagesLoaded(document.querySelector('.swiper-container'), () => {
      swipers.update();
    });
  }
};

const initFeaturedProjects = function () {
  let el = $('.featured-projects');
  if (el.length) {
    let swiper = new Swiper('.featured-projects', {
      effect: 'fade',
      speed: 1000,
      autoplay: {
        delay: 5000,
      }
    });

    // Reformat the slider when images are loaded
    imagesLoaded(document.querySelector('.featured-projects'), () => {
      swiper.update();
      el.addClass('featured-projects--visible');
    });
  }
};

/**
 * Init the swipers and store these in the swipers constant
 */
export const initSwiper = function() {
  initFullPageNav();
  initFeaturedProjects();
};